import { VictoryVoronoiContainer } from 'victory';
import { getLineGraphProps } from './helpers/getLineGraphProps';
import { periodTickFormatter } from '../helpers/periodTickFormatter';
import { Line } from './Line';
import { Legend } from './Legend';
import { Gradient } from './Gradient';
import { Tooltips } from './Tooltips';
import { formatNumber } from '@dop/shared/helpers/string';
import { Axis } from '../Axis';
import { WebAPILineGraphChartSlicerData } from '../../../globals/webApiTypes/elements/WebAPICBS';
import { getLineGraphTickLabelInlineSize } from './helpers/getLineGraphTickLabelInlineSize';
import { ChartContainer } from '../ChartContainer';
import { getVoronoiBlacklist } from './helpers/getVoronoiBlacklist';
import { chartPadding, yAxisLabelBlockSize } from '../cbsGraph.config';

export const LineGraph = ({
	title,
	description,
	periodType,
	unit,
	decimals,
	tickCount,
	tickValues,
	globalMin = 0,
	globalMax = 1,
	globalMiddle,
	periodDatesInRange,
	dimensionInfo,
}: WebAPILineGraphChartSlicerData & ReturnType<typeof getLineGraphProps>) => {
	const yAxisTickLabelInlineSize = getLineGraphTickLabelInlineSize({
		globalMin,
		globalMax,
		decimals,
	});

	return (
		<ChartContainer
			title={title}
			description={description}
			globalMin={globalMin}
			globalMax={globalMax}
			padding={{
				top: chartPadding.block,
				left: yAxisTickLabelInlineSize + yAxisLabelBlockSize,
				bottom: chartPadding.block,
				right: chartPadding.inline,
			}}
			containerComponent={
				<VictoryVoronoiContainer
					containerId={1}
					title={title}
					desc={description}
					voronoiBlacklist={getVoronoiBlacklist(dimensionInfo)}
				/>
			}
		>
			{dimensionInfo.map((singleDimensionInfo) =>
				Gradient(singleDimensionInfo),
			)}
			{dimensionInfo.map((singleDimensionInfo) =>
				Tooltips({
					...singleDimensionInfo,
					unit,
					decimals,
					globalMiddle,
					periodType,
				}),
			)}
			{Axis({
				tickValues: periodDatesInRange,
				tickFormat: periodTickFormatter({ periodType }),
				scale: 'time',
				tickCount: 6, // downsample to max 6 ticks
			})}
			{Axis({
				dependentAxis: true,
				tickCount,
				tickValues: tickValues,
				labelText: unit,
				tickFormat: (number: number) => formatNumber({ number, decimals }),
				tickLabelSpace: -1 * yAxisTickLabelInlineSize, // negative to offset towards inline-start
			})}
			{dimensionInfo.map((singleDimensionInfo) => Line(singleDimensionInfo))}
			{Legend({ dimensionInfo })}
		</ChartContainer>
	);
};
